var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"brand-logo"}},[_c('a',{attrs:{"href":_vm.dealer.url.home}},[_c('img',{staticClass:"brand-logo",class:_vm.brand.name,attrs:{"alt":"brand logo","width":"200","height":"200","src":_vm.brand.logoImage}})])])}
var staticRenderFns = []

export { render, staticRenderFns }